import {convertBreakpoint, debounce} from './utils';

var fixAriaOnResize = debounce(function() {
	let curSize = window.innerWidth;
	let buttons = document.querySelectorAll('[data-disableon]');
	if(buttons) {	
		buttons.forEach(button => {
			const att = button.getAttribute('data-disableon')
			const targetBP = convertBreakpoint(att)
			const targetElm = document.getElementById(button.getAttribute('aria-controls'))
			
			if(curSize >= targetBP && targetElm.getAttribute("style")!=='none') {
				button.setAttribute('aria-expanded', 'true');
			} else {
				button.setAttribute('aria-expanded', 'false');
			}
		});
	}
}, 500);

document.addEventListener("DOMContentLoaded", function(){
	fixAriaOnResize();
})
window.addEventListener('resize', fixAriaOnResize);